import validationClasses from "../config/validationClasses.js";
import cnMessages from "../lang/cn.js";
import enMessages from "../lang/en.js";
import jaMessages from "../lang/ja.js";
import twMessages from "../lang/tw.js";
import * as constants from "./constants.js";
/**
 * サポートする言語ごとのバリデーションメッセージのオブジェクト
 * @type {object.<string, Messages>}
 */
const languages = {
    ja: jaMessages,
    en: enMessages,
    cn: cnMessages,
    tw: twMessages,
};
/**
 * 言語に基づいてバリデーションルールとエラーメッセージを設定する関数
 * @param {string} language - 使用する言語
 * @returns {ConfigByLanguage}
 */
export function getConfigByLanguage(language) {
    var _a;
    const Messages = (_a = languages[language]) !== null && _a !== void 0 ? _a : languages.ja;
    /**
     * 各フィールドのバリデーションルールを定義
     * @constant {object} validationConfig
     */
    const validationConfig = {
        formArea: {
            check: validationClasses.formArea,
            excludedClasses: {
                preview: [".mw_wp_form_preview"],
                confirm: [".mw_wp_form_confirmation"],
            },
        },
        addr: {
            errText: Messages.ADDR,
        },
        required: {
            check: validationClasses.required,
            errText: Messages.REQUIRED,
        },
        requiredSelect: {
            errText: Messages.REQUIRED_SELECT,
        },
        anyRequired: {
            check: validationClasses.anyRequired,
            errText: Messages.ANY_REQUIRED,
        },
        tel: {
            regex: new RegExp(/^(?!.*(\d)\1{5})[0-9-]{8,}$/),
            check: validationClasses.tel,
            errText: Messages.TEL,
        },
        mail: {
            regex: new RegExp(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/),
            check: validationClasses.mail,
            errText: Messages.MAIL,
        },
        num: {
            regex: new RegExp(/^[0-9 ]+$/),
            check: validationClasses.num,
            errText: Messages.NUM,
        },
        alphabet: {
            regex: new RegExp(/^[a-zA-Z ]+$/),
            check: validationClasses.alphabet,
            errText: Messages.ALPHABET,
        },
        alphaNum: {
            regex: new RegExp(/^[0-9a-zA-Z ]+$/),
            check: validationClasses.alphaNum,
            errText: Messages.ALPHA_NUM,
        },
        zip: {
            regex: new RegExp(/^\d{3}[-]\d{4}$|^\d{7}$/),
            check: validationClasses.zip,
            errText: Messages.ZIP,
        },
        kana: {
            regex: new RegExp(/^[ぁ-んー　 ァ-ンヴーｧ-ﾝﾞﾟ\-]*$/),
            check: validationClasses.kana,
            errText: Messages.KANA,
        },
        hiragana: {
            regex: new RegExp(/^[ぁ-ん　 ー]*$/),
            check: validationClasses.hiragana,
            errText: Messages.HIRAGANA,
        },
        katakana: {
            regex: new RegExp(/^[ァ-ンヴ　 ーｧ-ﾝﾞﾟ\-]*$/),
            check: validationClasses.katakana,
            errText: Messages.KATAKANA,
        },
        file: {
            regex: new RegExp(`\\.(${constants.fileAllowedExtensions.join("|")})$`, "i"),
            check: validationClasses.file,
            errText: Messages.FILE,
        },
        upload: {
            check: validationClasses.formUpload,
            errText: Messages.UPLOAD,
        },
        confirm: {
            check: validationClasses.confirm,
            errText: Messages.CONFIRM,
        },
    };
    /**
     * 入力不備の場合の設定
     * @constant {object} noInputConfig
     */
    const noInputConfig = {
        classes: validationClasses.noInput,
        errText: Messages.NO_INPUT,
    };
    return { validationConfig, noInputConfig };
}
//# sourceMappingURL=config.js.map